import { render, staticRenderFns } from "./IconDialog.vue?vue&type=template&id=0f8fca34&scoped=true&"
import script from "./IconDialog.vue?vue&type=script&lang=js&"
export * from "./IconDialog.vue?vue&type=script&lang=js&"
import style0 from "./IconDialog.vue?vue&type=style&index=0&id=0f8fca34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8fca34",
  null
  
)

export default component.exports